///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-referral-types.collection.ts"/>
///<reference path="../common/data-template-base.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportReferralTypesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected referralTypes: ReportReferralTypesCollection;

        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.referralTypes;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.referralTypes = new ReportReferralTypesCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden,
                hiddenValue: options.hiddenValue || SmartMoverHiddenValue.EmptyArray
            });
            //this.tips = ['TIP_NOT_SELECTING_REFERRAL_TYPE'];
            this.title = 'LABEL_REFERRAL_TYPE';
            this.allSelectedLabel = 'LABEL_ALL_REFERRAL_TYPES';
            this.totalSelectedMessage = 'LABEL_TOTAL_REFERRAL_TYPES_SELECTED';
        }
    }
}